<template>
  <div id="container"
    :class="{'container':true,['curnav-'+ globalNavigationStore.selectedMenu]:true}">
    <header class="l-header">
      <global-navigation
              ref="refGlobalNavigation"
              :account-global-menu="accountGlobalMenu"
              :number-of-notification="accountStore.unReadNotification"
              :licensed-subject="globalNavigationStore.licensedSubject"
              :licensed-subject-for-nav="globalNavigationStore.licensedSubjectForNav"
              :clear-count="globalNavigationStore.accountStatus.number_of_mission_cleared_today"
              :star-count="globalNavigationStore.accountStatus.number_of_stars"
              :number-of-homeworks="globalNavigationStore.accountStatus.number_of_homeworks"
              :number-of-badges="globalNavigationStore.accountStatus.number_of_badges"
              :number-of-stars="numberOfStar"
              @update-clear-count="globalNavigationStore.accountStatus.number_of_mission_cleared_today=$event"
              @update-star-count="globalNavigationStore.accountStatus.number_of_stars=$event"
              @help="showHelp"
              @next-grade="openNextGradeModal1()">
      </global-navigation>
    </header>
    <popup-modal v-model="helpModal" @close="helpModal=false" @close-layer="helpModal=false" :is-help-modal="true" name="S2-3-help-close-btn">
      <template #main>
        <div class="topUseBlock" v-if="getHelp.length">
          <div class="title">{{getHelp[0].screen_name}}</div>
          <markdown-view :rawText="getHelp[0].body" :souruby="accountStore.isSouruby"></markdown-view>
        </div>
      </template>
      <template #footer>
        <a class="c-button-white -close" @click="helpModal=false" name="S2-3-help-stop-btn">
          <span class="label">
            閉じる
          </span>
        </a>
      </template>
    </popup-modal>
    <!--Important Notice Modal-->
    <popup-modal v-model="importantNoticeModal" @close="closeImportantNoticeModal" @close-layer="closeImportantNoticeModal" :is-help-modal="true" name="S2-3-notice-close-btn">
      <template #main>
        <div class="topNoticeBlock">
          <div class="title">重要なお知らせ</div>
          <ul class="list">
            <li class="list__item" v-if="numOfImportantUnreadNotice">
              <router-link :to="{name:'notice-detail', params: {uuid: accountStore.importantUnReadNotice[0].uuid}}">
                {{accountStore.importantUnReadNotice[0].title}}
              </router-link>
            </li>
          </ul>
          <p class="total" v-if="numOfImportantUnreadNotice>1">他<span>{{numOfImportantUnreadNotice-1}}</span>件</p>
        </div>
      </template>
      <template #footer>
        <router-link :to="{ name: 'notice', params: { page_number: '1' } }" class="c-button-white -arrow -modal">
          <span class="label">
            お知らせ一覧へ
          </span>
        </router-link>
      </template>
    </popup-modal>
    <!-- next grade modal 1 -->
    <popup-modal v-model="nextGradeModal1" @close="closeNextGradeModal1" @close-layer="closeNextGradeModal1" :is-next-grade-modal="true" name="S2-3-next-grade-1-close-btn">
      <template #main>
        <div class="c-popup-body__head">
          <p class="c-popup-body__head-title">
            新年度の学級・出席番号を入力してください
          </p>
        </div>
        <div class="c-popup-body__titleBox">
          <p class="c-parts-alert-box">
            ※学級・出席番号入力について先生の指示がまだの場合は「あとでやる」ボタンを押し、<br>
            　先生から指示を受けた後に入力してください。</p>
          <div class="c-popup-body__titleBox-text">
            <p class="u-text-center">
              新年度の学級を選択して、出席番号を入力してください
              <span class="u-text-note">※学級・出席番号を入力すると、新年度の教材を使用できるようになります。</span>
            </p>
            <div :class="{'c-parts-listbox-wrapper': true, '-error': isAttendanceNumber}">
              <dl class="c-parts-listbox -class">
                <dt class="title">学級</dt>
                <dd class="contents">
                  <div class="c-form-select">
                    <div class="output open" @click="toggleClassroomSelect()" ref="refOutput" name="next-grade-classroom-select-toggle-btn">
                      <div class="label" v-if="selectedClassroom">{{ selectedClassroom.name }}</div>
                      <div class="label" v-else>学級を選択してください</div>
                      <div class="arrow" ref="refArrow"></div>
                    </div>
                    <div class="option" ref="refSelectListBox">
                      <ul class="option__list -left">
                        <li :data-select-value="item.name" :value="item.name" v-for="item in nextGradeStore.classroom_list" :key="item.id" @click="selectedClassroom=item">
                          <span class="label">{{ item.name }}</span>
                        </li>
                      </ul>
                    </div>
                    <p class="error" v-if="isClassroom">教室を選択する必要があります</p>
                  </div>
                </dd>
              </dl>
              <dl class="c-parts-listbox -num">
                <dt class="title">出席番号</dt>
                <dd class="contents">
                  <ul class="input-area-wrapper">
                    <li :class="{'input-area': true, 'is-focus': isFocusAttendanceNumber}">
                      <p 
                        class="answerTextarea__input" 
                        contenteditable="plaintext-only" 
                        placeholder="入力してください"
                        v-text="attendanceNumber" 
                        @input="inputAttendanceNumber"
                        @focus="isFocusAttendanceNumber=true"
                        @blur="isFocusAttendanceNumber=false">
                      </p>
                    </li>
                  </ul>
                  <p class="error" v-if="isAttendanceNumber">出席番号には、英数字・ハイフン・半角スペースのみ使用できます。</p>    
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="c-button -col2 -medium">
          <span class="c-button-white -medium -font-large" @click="closeNextGradeModal1">
            <span class="label">
              あとでやる
            </span>
          </span>
          <span class="c-button-blue -medium" @click="openNextgradeModal2">
            <span class="label">
              入力内容を確認する
            </span>
          </span>
        </div>
      </template>
    </popup-modal>
    <!-- next grade modal 2 -->
    <popup-modal v-model="nextGradeModal2" @close="closeNextGradeModal2" @close-layer="closeNextGradeModal2" :is-next-grade-modal="true" name="S2-3-next-grade-2-close-btn">
      <template #main>
        <div class="c-popup-body__head">
          <p class="c-popup-body__head-title">
            新年度の学級・出席番号を保存します
          </p>
        </div>
        <div class="c-popup-body__titleBox">
          <div class="c-popup-body__titleBox-text">
            <p class="u-text-center">
              学級・出席番号を保存してよろしいでしょうか？
            </p>
            <p class="u-text-center u-text-caution">
              ※一度保存してしまうと自分では変更できません。<br>
              変更が必要な場合は、先生へ連絡してください。
            </p>
            <div class="c-parts-listbox-wrapper">
              <dl class="c-parts-listbox -class -confirm">
                <dt class="title">学級</dt>
                <dd class="contents">
                  {{ selectedClassroom?.name }}
                </dd>
              </dl>
              <dl class="c-parts-listbox -num -confirm">
                <dt class="title">出席番号</dt>
                <dd class="contents">
                  <ul class="input-area-wrapper">
                    <li class="input-area">
                      {{ attendanceNumber }}
                    </li>    
                  </ul>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="c-button -col2 -medium">
          <span class="c-button-white -medium -font-large" @click="openNextGradeModal1(false)">
            <span class="label">
              修正する
            </span>
          </span>
          <span class="c-button-blue -medium" @click="openNextgradeModal3">
            <span class="label">
              学級・出席番号を保存する
            </span>
          </span>
        </div>
      </template>
    </popup-modal>
    <!-- next grade modal 3 -->
    <popup-modal v-model="nextGradeModal3" @close="closeNextGradeModal3" @close-layer="closeNextGradeModal3" :is-next-grade-modal="true" name="S2-3-next-grade-3-close-btn">
      <template #main>
        <div class="c-popup-body__head">
          <p class="c-popup-body__head-title">
            新年度の学級・出席番号を保存しました
          </p>
        </div>
        <div class="c-popup-body__titleBox">
          <div class="c-popup-body__titleBox-text">
            <p class="u-text-center">
              新年度の学級・出席番号を保存しました。
            </p>
            <p class="u-text-center u-text-caution">
              ※変更が必要な場合は、先生へ連絡してください。
            </p>
            <div class="c-parts-listbox-wrapper">
              <dl class="c-parts-listbox -class -confirm">
                <dt class="title">学級</dt>
                <dd class="contents">
                  {{ selectedClassroom?.name }}
                </dd>
              </dl>
              <dl class="c-parts-listbox -num -confirm">
                <dt class="title">出席番号</dt>
                <dd class="contents">
                  <ul class="input-area-wrapper">
                    <li class="input-area">
                      {{ attendanceNumber }}
                    </li>    
                  </ul>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="c-button -col1 -medium">
          <span class="c-button-blue -medium" @click="closeNextGradeModal3">
            <span class="label">
              閉じる
            </span>
          </span>
        </div>
      </template>
    </popup-modal>
    <!--// content -->
    <slot name="main-content"></slot>
  </div>
</template>

<script setup lang="ts">
  import {ref, computed, onMounted, onUnmounted} from "vue";
  import {useRoute} from "vue-router";
  import {event, set as gtagSet} from "vue-gtag"
  import { isEnvCaptureGoogleAnalyticsEvents } from "@/util/env"
  import { useGlobalNavigationStore } from '@/store/student/global_navigation_store';
  import { useAccountStore } from '@/store/student/account_store';
  import {useWorkStore} from '@/store/student/work_store';
  import { useNextGradeStore } from "@/store/student/next_grade";

  withDefaults(
    defineProps<{
      accountGlobalMenu?: boolean;
    }>(),
    {
      accountGlobalMenu: false,
    }
  );
  const globalNavigationStore = useGlobalNavigationStore()
  const accountStore = useAccountStore()
  const workStore = useWorkStore()
  const nextGradeStore = useNextGradeStore()
  const numberOfStar = ref(0)
  const helpModal = ref(false)
  const importantNoticeModal = ref(false)
  const nextGradeModal1 = ref(false)
  const nextGradeModal2 = ref(false)
  const nextGradeModal3 = ref(false)
  const route = useRoute()
  const refGlobalNavigation = ref(null)
  const selectedClassroom = ref(null)
  const attendanceNumber = ref("")
  const isFocusAttendanceNumber = ref(false)
  const refOutput = ref(null)
  const refArrow = ref(null)
  const refSelectListBox = ref(null)
  const isVisible = ref(false);
  const zIndex = ref(10);
  const isClassroom = ref(false)
  const isAttendanceNumber = ref(false)
  const isNextGradeSaveBtnLocked = ref(false)

  onMounted( async() => {
    window.addEventListener('click', closeDropdown)
    const metaTag = document.querySelector('meta[name="robots"][content="noarchive"]');
    if (metaTag) {
        metaTag.remove(); // Remove the meta tag from the document head
    }
    if(!accountStore.isGtagConfig){
      accountStore.saveIsGtagConfig(true)
      await globalNavigationStore.fetchNavAccountStatus(null)
      await accountStore.fetchAlreadyReadNotifications()
      await accountStore.fetchListNotifications()
      // NFR-4440 ナビゲーションとワークAPIは１回のみ呼ばれるようにapp layoutで設定する。
      await globalNavigationStore.fetchNavSubjects()
      await workStore.fetchWorks()
      if(numOfImportantUnreadNotice.value && route.name!='notice'){
        importantNoticeModal.value = true
      } else {
        // NFR-5610: to show next grade modal
        closeImportantNoticeModal()
      }
      if(isEnvCaptureGoogleAnalyticsEvents()){
        // google analytic dimension config
        gtagSet({
            'user_id': accountStore.userId,
            'user_properties': {
              'school_name': accountStore.schoolName
            }
        })
        event('page_load', {'school_name': accountStore.schoolName})
      }
    }
  })
  const numOfImportantUnreadNotice = computed(() => {
    return accountStore.importantUnReadNotice.length
  })
  const getHelp = computed(() => {
    let help = globalNavigationStore.helpList.filter((item) => item.screen_code === route.meta.screenCode)
    if(help.length>0){
      return help
    }else{
        return globalNavigationStore.helpList.filter((item) => item.screen_code === "S0-0")
    }
  })
  const attendanceNumberValidation = computed(() => {
    // validate attendance number pattern with half-width and full-width alphanumeric characters, hyphen, and space allow only
    const pattern = /^[\uFF21-\uFF3A\uFF41-\uFF5A\uFF10-\uFF19a-zA-Z0-9　\s－-]*$/;
    let isValid = false
    if(attendanceNumber.value.match(pattern)){
      isValid = true
    }
    return isValid
  })
  function closeImportantNoticeModal(){
    importantNoticeModal.value = false
    if(nextGradeStore.classroom_list.length > 0){
      if(nextGradeStore.modal_display_time == null){
        nextGradeModal1.value = true
      } else {
        const datetime_now: Date = new Date() // Get current datetime
        const modal_display_time: Date = new Date(nextGradeStore.modal_display_time) // Convert string to Date
        const timeDiffInMs: number = datetime_now.getTime() - modal_display_time.getTime() // Calculate the difference in milliseconds
        const timeDiffInHours: number = timeDiffInMs / (1000 * 60 * 60) // Convert ms to hours
        if(timeDiffInHours > 24){ // 24時間以上経過していたら表示
          nextGradeModal1.value = true
        }
      }
    }
  }
  function showHelp(){
      helpModal.value = true
      if(globalNavigationStore.helpList.length==0){
        globalNavigationStore.fetchHelp()
      }
      if(isEnvCaptureGoogleAnalyticsEvents()){
        event('show_help', {
            'screen_code': route.meta.screenCode
        })
      }
  }
  function saveModalDisplayTime(){
    // save modal display time
    nextGradeStore.saveModalDisplayTime()
  }
  function openNextGradeModal1(reset=true){
    // reset all error flags
    isAttendanceNumber.value = false
    isClassroom.value = false
    // reset form binding values if start over
    if(reset){
      selectedClassroom.value = null
      attendanceNumber.value = ""
    }
    nextGradeModal2.value = false
    nextGradeModal3.value = false
    nextGradeModal1.value = true
  }
  function closeNextGradeModal1(){
    nextGradeModal1.value = false
    saveModalDisplayTime()
  }
  function toggleClassroomSelect(isVisibleLocal=false){
    if(isVisibleLocal){
      isVisible.value = false
    }
    else{
      isVisible.value = !isVisible.value;
    }
    if (refOutput.value && refSelectListBox.value){
      if(isVisible.value){
        refOutput.value.style.zIndex = zIndex.value;
        refSelectListBox.value.style.display = "block";
        refSelectListBox.value.style.opacity = 1;
        zIndex.value++;
      }
      else{
        refOutput.value.style.zIndex = 0;
        refSelectListBox.value.style.display = "none";
        refSelectListBox.value.style.opacity = 0;
      }
    }
  }
  function closeDropdown(e: any){
    // close dropdown when clicked outside
    if(!(refOutput.value == e.target || refArrow.value == e.target)){
      toggleClassroomSelect(true)
    }
  }
  function inputAttendanceNumber(event: any){
    // Regular expression to allow only alphanumeric characters, spaces, and hyphens half and full width
    const regex = /[^\uFF21-\uFF3A\uFF41-\uFF5A\uFF10-\uFF19a-zA-Z0-9　\s－-]/g;
    // Get the current text content of the paragraph
    let text = event.target.textContent;
    // Replace any character that doesn't match the regex with an empty string
    let filteredText = text.replace(regex, '');
    // Update the paragraph's content with the filtered text
    if (text !== filteredText) {
      event.target.innerText = filteredText;

        // Move the cursor to the end of the text
        const range = document.createRange();
        const selection = window.getSelection();
        range.selectNodeContents(event.target);
        range.collapse(false); // Move cursor to the end
        selection.removeAllRanges();
        selection.addRange(range);
    }
    // binding input value to attendanceNumber
    attendanceNumber.value = event.target.textContent
    // reset all error flags
    isAttendanceNumber.value = false
    isClassroom.value = false
  }
  function openNextgradeModal2(){
    // validate classroom and attendance number checking
    if(!attendanceNumberValidation.value){
      isAttendanceNumber.value = true
    }
    if(selectedClassroom.value === null){
      isClassroom.value = true
    }
    if(attendanceNumberValidation.value && selectedClassroom.value !== null && nextGradeStore.classroom_list.length > 0){
      nextGradeModal1.value = false
      nextGradeModal2.value = true
      nextGradeModal3.value = false
    }
  }
  function closeNextGradeModal2(){
    nextGradeModal2.value = false
    saveModalDisplayTime()
  }
  function normalizeNextGradeModalValue(text: string){
    // If the text is null, return an empty string
    if(text === null){
      return ""
    }
    // remove all new lines from text
    text = text.replace(/\n/g, '')
    // Convert full-width characters to half-width characters
    text = text.replace(/[\uFF01-\uFF5E]/g, (char) => {
      // Convert full-width to half-width by adjusting the Unicode code point
      return String.fromCharCode(char.charCodeAt(0) - 0xFEE0);
    });
    // Convert full-width hyphen to half-width hyphen
    text = text.replace(/\u2010/, "-")
    // Convert full-width space to half-width space
    text = text.replace(/\u3000/g, " ")
    // Compress consecutive spaces into one
    text = text.replace(/\s+/g, " ");
    // Trim leading and trailing spaces
    text = text.trim()
    // Return the normalized text
    return text
  }
  async function openNextgradeModal3(){
    // NFR-6090 保存ボタンが連打できないようにする
    if(isNextGradeSaveBtnLocked.value){return}
    if(attendanceNumberValidation.value && selectedClassroom.value !== null && nextGradeStore.classroom_list.length > 0){
      // NFR-6090 保存ボタンをロック
      isNextGradeSaveBtnLocked.value = true
      try{
        // normalize classroom and attendance number 
        const normalizeSelectedClassroom = normalizeNextGradeModalValue(selectedClassroom.value.id.toString())
        const normalizedAttendanceNumber = normalizeNextGradeModalValue(attendanceNumber.value)
        // save classroom and attendance number to database
        await nextGradeStore.saveClassroomStudent(normalizeSelectedClassroom, normalizedAttendanceNumber)
        nextGradeModal1.value = false
        nextGradeModal2.value = false
        nextGradeModal3.value = true
        // fetch account profile after update classroom and attendance number
        accountStore.fetchAccountProfile()
      }catch(error){
        console.log("error: ", error)
      }finally{
        // NFR-6090 処理が完了したのでボタンを再度アンロック
        isNextGradeSaveBtnLocked.value = false
      }
    }
  }
  function closeNextGradeModal3(){
    nextGradeModal3.value = false
    saveModalDisplayTime()
  }
  onUnmounted(() => {
    window.removeEventListener('click', closeDropdown)
  })
  defineExpose({
    refGlobalNavigation,
    numberOfStar,
    openNextGradeModal1, // NFR-5653: to show next grade modal from account page
  })
</script>
